import { createFileRoute } from "@tanstack/react-router";
import { PromptSettingsPage } from "@/features/ai/prompt-settings-page";

export const Route = createFileRoute("/_authenticated/ai/prompt/")({
  head: () => ({ meta: [{ title: "Rogue prompt · Rogue Admin" }] }),
  component: PromptSettingsPage,
});
